import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login.vue'

Vue.use(VueRouter)

const routes = [
	{
	  path: '/',
	  name: 'login',
	  component: Login
	},
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/index',
    name: 'index',
    component: () => import( '@/views/index.vue')
  },
  {
    path: '/scale',
    name: 'scale',
    component: () => import( '@/views/scaleList.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import( '@/views/detail.vue')
  },
  {
    path: '/start',
    name: 'start',
    component: () => import( '@/views/start.vue')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import( '@/views/report.vue')
  },
  {
    path: '/report2',
    name: 'report2',
    component: () => import( '@/views/report2.vue')
  },
  {
    path: '/userCenter',
    name: 'userCenter',
	meta:{
		keepAlive:true,
		isBack:false,
	},
    component: () => import( '@/views/userCenter.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
